var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      ref: "nsSearchbar",
      staticClass: "ns-searchbar",
      class: {
        "cart-mode": _vm.mode === "cart",
        "new-header": _vm.newHeader,
        focused: _vm.focused,
        not_focused: !_vm.focused,
        slotted: _vm.theme === "slotted",
        not_slotted: _vm.theme !== "slotted"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "input-container",
          class: { "cart-mode": _vm.mode === "cart" }
        },
        [
          _c("NsSearchbarInput", {
            attrs: {
              value: _vm.tempValue || _vm.searchValue,
              translations: _vm.localTranslations,
              "new-header": _vm.newHeader,
              focused: _vm.focused,
              "no-search-button": _vm.noSearchButton,
              "show-tooltip": _vm.showIconsContainerTooltip
            },
            on: {
              "disable-input-tooltip": _vm.disableInputTooltip,
              input: _vm.input,
              focus: _vm.focus,
              blur: _vm.blur,
              "analyze-key": _vm.analyzeKey,
              "clear-input": _vm.clearInput
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "searchListings",
              staticClass: "search-listings",
              attrs: { id: "searchListings" }
            },
            [
              _vm._t("searchResults", [
                _vm.showRecentList
                  ? _c("NsSearchbarList", {
                      attrs: {
                        mode: _vm.mode,
                        "search-data": _vm.recentSearchData,
                        title: _vm.localTranslations.clearSearch,
                        translations: _vm.localTranslations,
                        type: "recent"
                      },
                      on: {
                        "clear-recent-searches": _vm.clearRecentSearches,
                        "toggle-value": _vm.toggleValue,
                        "add-to-cart": _vm.addToCart,
                        "click-search-item": _vm.selectSearchItem
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showPredictiveList
                  ? _c("NsSearchbarList", {
                      attrs: {
                        "hide-see-more-results": _vm.hideSeeMoreResults,
                        mode: _vm.mode,
                        "prices-loading": _vm.pricesLoading,
                        "search-data": _vm.predictiveSearchData,
                        "show-more-button": _vm.showMoreButton,
                        "show-pricing-in-predictive": _vm.predictivePricing,
                        translations: _vm.localTranslations,
                        type: "predictive"
                      },
                      on: {
                        "toggle-value": _vm.toggleValue,
                        "click-search-item": _vm.selectSearchItem,
                        "add-to-cart": _vm.addToCart,
                        "see-more-results": _vm.seeMoreResults
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showPopularList
                  ? _c("NsSearchbarList", {
                      attrs: {
                        mode: _vm.mode,
                        "search-data": _vm.popularSearchResults,
                        title: _vm.localTranslations.popularSearches,
                        translations: _vm.localTranslations,
                        type: "popular"
                      },
                      on: {
                        "click-search-item": _vm.selectSearchItem,
                        "toggle-value": _vm.toggleValue,
                        "add-to-cart": _vm.addToCart
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "search-section" },
                _vm._l(_vm.slottedSearchedItems, function(item, index) {
                  return _c(
                    "div",
                    { key: index },
                    [_vm._t("ns-searchbar-slotted-searched-item-" + index)],
                    2
                  )
                }),
                0
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.noSearchButton && _vm.mode !== "cart"
        ? _vm._t("submitButton", [
            _c("NsSearchbarButton", {
              attrs: {
                translations: _vm.localTranslations,
                "new-header": _vm.newHeader,
                focused: _vm.focused,
                "submit-button-active": _vm.submitButtonActive,
                "show-tooltip": _vm.showSearchButtonTooltip
              },
              on: {
                "disable-search-tooltip": _vm.disableSearchTooltip,
                "submit-search": _vm.submitSearch
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.newHeader
        ? _c(
            "div",
            {
              staticClass: "mobile-search-button",
              on: {
                click: function($event) {
                  _vm.focused = true
                }
              }
            },
            [
              _c("NsIcon", {
                staticClass: "search-icon",
                attrs: { "icon-name": "icon-search" }
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.localTranslations.search))])
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }